/* eslint-disable react/prop-types */
import React, { PureComponent } from 'react';
import * as PropTypes from 'prop-types';

import { DeTableHeaderRowCell } from 'cv-library-react-web';
// import { constants, searchController } from 'cv-react-core';

import getStyles from './TableHeaderCell.styles';

class TableHeaderCell extends PureComponent {
    static propTypes = {
        hearderBaseProps: PropTypes.object,
        isSearchFormOpen: PropTypes.bool,
    };

    static defaultProps = {
        isSearchFormOpen: false,
    };

    render() {
        const { hearderBaseProps, isSearchFormOpen } = this.props;
        const {
            style,
            column,
            position } = hearderBaseProps;

        const {
            isFiltered,
            fixedColumn } = column;

        if (!isSearchFormOpen) this.isFiltered = isFiltered;
        const componentStyle = getStyles(style, isSearchFormOpen ? this.isFiltered : isFiltered, fixedColumn);

        const tableHeaderRowCellProps = {
            ...hearderBaseProps,
            style: { ...componentStyle, left: fixedColumn ? position : 'unset'},
            draggingEnabled: !fixedColumn,
        };
        return React.createElement(DeTableHeaderRowCell, { ...tableHeaderRowCellProps });
        // const childrenWithProps = React.Children.map(children, (child) => {
        //     // checking isValidElement is the safe way and avoids a typescript error too
        //     if (React.isValidElement(child)) {
        //       return React.cloneElement(child, {
        //         name,
        //         title,
        //         isAscending,
        //         fixedColumn,
        //         priority,
        //         isSearchFormOpen,
        //         onSortColumn,
        //         onColumnFrozen });
        //     }
        //     return child;
        //   });
        // return React.createElement(DeTableHeaderRowCell, { ...tableHeaderRowCellProps }, childrenWithProps);
    }

    // Use this to preserve existing sort information since we have to look at the searchDialogStore directly for these values.
    // Otherwise you will see the grids update as users update information in advanced search.
    isFiltered;
    sortValue;
}

export default TableHeaderCell;
